// extracted by mini-css-extract-plugin
export default {"table":"ProductListUpload_table__ON6PF"};